import ColorPickerInput from '~/components/Input/ColorPickerInput';
import type { InputProps } from '~/components/Input/Input';
import Input, { InputField, MaskedInputField } from '~/components/Input/Input';

export default Input;
export { InputField, MaskedInputField, ColorPickerInput, InputProps };
